import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/inventory/fuelContract';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = state => {

	/** @namespace state.lists.fuelContractIds **/
	/** @namespace state.maps.fuelContract **/
	/** @namespace state.maps.user **/
	let fuelContracts;
	if (state.lists.fuelContractIds) {
		fuelContracts = _.map(state.lists.fuelContractIds, id => state.maps.fuelContract[id]);
	}
	const canRwContracts = !!(_.get(state.auth.authUser, ['permissions', 'canRwContracts'], false));
	return {
		fuelContracts,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		resourceMap : state.maps.resource,
		canRwContracts,
		accessToken: state.auth.accessToken,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchFuelContracts : search,
	removeFuelContracts : remove,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
